// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-default: #E5D1AB;
  --bg-primary: #E5D1AB;
  --bg-secondary: #D8BF92;

  --white: #F4E7CA;
  --grey: #9B876A;
  --bg-primary-light: #4E91A1;
  --grey-light: rgba(155, 135, 106, 0.25);
  --box-shadow-light: rgba(111, 81, 39, 0.20);
  --typo-primary: #F4E7CA;
  --disabled-color: #B7A383;
  --common-border-radius: 4px;
}

html {
  background-color: var(--color-midnight, #0F1C26);
}

.App {
  min-height: 100vh;
  text-align: center;
  color: var(--color-ink, #1F1A16);
}

.MuiList-root {
  padding-bottom: 0 !important;
}

.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.closeicon {
  position: absolute !important;
  top: 1rem !important;
  right: 1rem;
  z-index: 9999999;
  fill: var(--color-ivory, #F4E7CA);
  cursor: pointer;
}

.MuiPaper-root {
  color: var(--color-ink, #1F1A16);
  background-color: var(--color-ivory, #F4E7CA);
  border-color: var(--color-gold, #B58A43);

  @media (max-width: 768px) {
    width: 100%;
    overflow: hidden;
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-track {
  background-color: #132635;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #8D6A35;
  border: 1px solid #B58A43;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #B58A43;
}

.app-route-loader {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #F4E7CA;
  background:
    radial-gradient(circle at center, rgba(77,126,136,0.18), transparent 42%),
    #0F1C26;
  font: 600 16px/1.4 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;;EAEvB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,uCAAuC;EACvC,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;EAC7C,wCAAwC;;EAExC;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd;;WAES;EACT,uFAAuF;AACzF","sourcesContent":[":root {\n  --bg-default: #E5D1AB;\n  --bg-primary: #E5D1AB;\n  --bg-secondary: #D8BF92;\n\n  --white: #F4E7CA;\n  --grey: #9B876A;\n  --bg-primary-light: #4E91A1;\n  --grey-light: rgba(155, 135, 106, 0.25);\n  --box-shadow-light: rgba(111, 81, 39, 0.20);\n  --typo-primary: #F4E7CA;\n  --disabled-color: #B7A383;\n  --common-border-radius: 4px;\n}\n\nhtml {\n  background-color: var(--color-midnight, #0F1C26);\n}\n\n.App {\n  min-height: 100vh;\n  text-align: center;\n  color: var(--color-ink, #1F1A16);\n}\n\n.MuiList-root {\n  padding-bottom: 0 !important;\n}\n\n.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.closeicon {\n  position: absolute !important;\n  top: 1rem !important;\n  right: 1rem;\n  z-index: 9999999;\n  fill: var(--color-ivory, #F4E7CA);\n  cursor: pointer;\n}\n\n.MuiPaper-root {\n  color: var(--color-ink, #1F1A16);\n  background-color: var(--color-ivory, #F4E7CA);\n  border-color: var(--color-gold, #B58A43);\n\n  @media (max-width: 768px) {\n    width: 100%;\n    overflow: hidden;\n  }\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n::-webkit-scrollbar {\n  width: 7px;\n  height: 7px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #132635;\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #8D6A35;\n  border: 1px solid #B58A43;\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #B58A43;\n}\n\n.app-route-loader {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #F4E7CA;\n  background:\n    radial-gradient(circle at center, rgba(77,126,136,0.18), transparent 42%),\n    #0F1C26;\n  font: 600 16px/1.4 system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
